// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"4bdea11f","769":"de750eda"}[chunkId] + ".chunk.css";
};